// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + (chunkId === 348 ? "APP " : chunkId) + "." + {"348":"4ffa2c4b","968":"761198ee"}[chunkId] + ".chunk.css");